import { createRoutine } from 'redux-saga-routines';

export const changeWorkSpace = createRoutine('CHANGE_WORKSPACE');
export const getWorkSpaces = createRoutine('GET_WORKSPACES');
